import { httpClient } from 'utils/httpClient';
import { Ticket, TicketPayload } from 'types/ticket.types';

export const ticketService = {
  /** POST /tickets */
  crear(payload: TicketPayload): Promise<Ticket> {
    return httpClient.post<Ticket>('/tickets', payload);
  },

  /** GET /tickets?directorId={id}&dni={dni} */
  listar(directorId: number, dni: string): Promise<Ticket[]> {
    return httpClient.get<Ticket[]>(`/tickets?directorId=${directorId}&dni=${dni}`);
  },
};
